import React, { useEffect, useRef, useState } from "react";

import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
// import { DatePicker } from '@mui/x-date-pickers/DatePicker';

import EventIcon from "@mui/icons-material/Event";

import {
  Box,
  Divider,
  Fab,
  Grid,
  Tab,
  Tabs,
  TextField,
  Typography,
} from "@mui/material";
import {
  getAccountReachageDetails,
  getAllEmployeeList,
} from "./appoinmentDashboardApi";
import SmbAccountReachargeCard from "./AppoinmentDashboardCard";
import AddIcon from "@mui/icons-material/Add";
import { getData } from "./smbAccountRechargeCustomApiHandler";

import {
  convertDateToCustomFormat,
  getFirstDateOfMonth,
  getStartOfMonth,
} from "../../utils/commonUtils";
import AppoinmentDashboardCard from "./AppoinmentDashboardCard";
import { DatePicker } from "@mui/x-date-pickers";
import DatePickerComponent from "../../common/curstomDatePicker";
import FormModal from "./FormModal";
import DynamicBreadcrumbs from "../../common/Breadcrumb";
import { useSelector } from "react-redux";
import EmployeeDetail from "./educationalDetail";
import ExpenceEmp from "./expenceEmp";
import CardPayment from "../payment/cardPayment";
import FormModalShareMessageProfile from "./formDataShareMessage";

export default function EmployeeInfo({ gridSize,config }) {
  const cardKet = {
    persnoalInf: [
      {
        key: "employeeId",
        label: "Employee Id",
        color: "#bb4a9b",
      },
      {
        key: "name",
        label: "Employee Name",
        color: "#bb4a9b",
      },
      {
        key: "address",
        color: "black",
        label: "Address",
      },
      {
        key: "mobile",
        color: "black",
        label: "Mobile",
      },
      {
        keys: ["paymentPercentage", "salaryorPercentage"],
        color: "#3695B6",
        label: "Payment Percentage",
      },
    ],
    educationalDetail: [
      {
        key: "courseName",
        label: "Course Name",
      },
      {
        key: "courseDetails",
        label: "Component Name",
      },
      {
        key: "durationInYear",
        label: "Duration In Year",
      },
      {
        key: "percentage",
        label: "Percentage",
      },

      {
        key: "grade",
        label: "grade",
      },
      {
        key: "institute",
        label: "institute",
      },
      {
        key: "university",
        label: "university",
      },
    ],

    incentrive: [
      {
        key: "incentiveName",
        label: "Incentive Name",
      },
      {
        key: "minimumValue",
        label: "Minimum Value",
      },
      {
        key: "maximumValue",
        label: "Maximum Value",
      },

      {
        key: "percentage",
        label: "percentage",
      },
    ],
    Deductions: [
      {
        key: "componentName",
        label: "Component Name",
      },
      {
        key: "amount",
        label: "Amount",
      },

      {
        key: "percentage",
        label: "Percentage",
      },
    ],
  };
  // const [data, setData] = useState();
  const [open, setOpen] = useState(false);

  const datePickerRef = useRef();
  const openDatePicker = () => {
    if (datePickerRef.current) {
      datePickerRef.current.setOpen(true);
    }
  };
  const [date, setDate] = useState(getStartOfMonth());

  const [SelectedStartDate, setSelectedStartDate] = useState(
    getFirstDateOfMonth()
  );
  const [openT,setOpenT]=useState(false)

  const [modalData, setModalData] = useState(null);
  const [modalDataT, setModalDataT] = useState(null);
  const [value, setValue] = React.useState("Unassigned");
  const [data, setData] = useState();
  const [valuet, setValuet] = React.useState("Assigned");
  const businessChooseTab = useSelector(
    (state) => state.reducer.businessChooseTab
  );

  const handleChange = (event, newValue) => {
    // setPageNo(1);

    setValue(newValue);
  };
  const handleChanget = (event, newValue) => {
    // setPageNo(1);

    setValuet(newValue);
  };

  useEffect(() => {
    getAllEmployeeList((res) => {
      console.log("getAllEmployeeList", res);
      setData(res?.list);
    });
    // getData(getAccountReachageDetails, setData);
  }, []);
  const [selectedDate, setSelectedDate] = React.useState(null);
  const [isDatePickerOpen, setIsDatePickerOpen] = React.useState(false);

  const handleOpenDatePicker = () => {
    setIsDatePickerOpen(true);
  };

  const handleCloseDatePicker = () => {
    setIsDatePickerOpen(false);
  };
  const [validationMsgFlag, setValidationMsgFlag] = useState(null);
  useEffect(() => {
    console.log("modalData parent", data);
  }, [data]);
  useEffect(() => {
    if (open == false) {
      // setModalData({});
    }
  }, [open]);
  return (
    <>
      <DynamicBreadcrumbs />
      {(businessChooseTab?.value == "PersnalInfo"  || config?.personalInfo) && (
        <>
          <Box
            sx={{
              margin: {
                xs: "10px",
                sm: "50px 10px 10px 10px ",
                md: "50px",
              },
            }}
          >
            <Grid container>
              <Grid
                item
                xs={6}
                sx={{
                  display: "flex",
                  justifyContent: "right",
                  alignItems: "center",
                }}
              >
                {" "}
              </Grid>

              <Grid
                item
                xs={6}
                sx={{
                  display: "flex",
                  justifyContent: "right",
                  alignItems: "center",
                }}
              >
                {" "}
                {!gridSize && !config && (
                  <Fab
                    onClick={() => {
                      // setOpen(true);

                      setOpen(true);
                    }}
                    sx={{
                      mb: 3,
                      zIndex: "0",
                      textTransform: "capitalize",
                      width: {
                        xs: "100%",
                        sm: "auto",
                      },
                      // p: "10px",
                      whiteSpace: "nowrap",
                    }}
                    size="small"
                    color="primary"
                    variant="extended"
                    aria-label="add"
                  >
                    Add Employee
                    <AddIcon />
                  </Fab>
                )}
              </Grid>

              <>
                {" "}
                <Grid container spacing={2}>
                  {data?.map((item, index) => (
                    <Grid item xs={4} key={index}>
                      <CardPayment
                        item={item}
                        setOpen={(data) => {}}
                        setModalData={(dat) => {
                          console.log("upupupupup ",dat)
                          let obj={}
                          Object.keys(dat).map((key,index)=>{
                            if(dat[key] && dat[key]!="null" ) {
                              obj[key]=dat[key]
                            }
                            else{
                              obj[key]=""
                            }
                          })
                          console.log("objobjobjobj",obj)
                         if(!config){
                          setModalData({...obj,
                          });
                          setOpen(true);
                         }
                         if(config){
                          setModalDataT(obj);
                          setOpenT(true);
                         }
                        }}
                        cardKet={cardKet?.persnoalInf}
                      />
                    </Grid>
                  ))}
                </Grid>
                <FormModal
                
                
                  open={open}


                  setModalData={setModalData}
                  
                  setOpen={setOpen}
                  getAll={() => {
                    getAllEmployeeList((res) => {
                      console.log("getAllEmployeeList", res);
                      setData(res?.list);
                    });
                  }}
                  modalData={modalData}
                />
                <FormModalShareMessageProfile
                open={openT}
                setOpen={setOpenT}
                getAll={() => {
                  getAllEmployeeList((res) => {
                    console.log("getAllEmployeeList", res);
                    setData(res?.list);
                  });
                }}
                modalData={modalDataT}
                />
                
              </>
            </Grid>
          </Box>{" "}
        </>
      )}
      {/* {
        businessChooseTab?.value=="PersnalInfo" &&
        <>
        <EmployeeDetail /> 
        </>
        
      } */}
      {businessChooseTab?.value == "EducatoinalDetail" && (
        <>
          <EmployeeDetail />
        </>
      )}
      {businessChooseTab?.value == "expence" && <ExpenceEmp />}
    </>
  );
}
